import { useIntl } from 'react-intl';

import '../style.scss';

type PrecomPriceProps = {
  preComPrice?: number;
  quoteStatus?: boolean;
};

const PrecomPrice = ({ preComPrice, quoteStatus }: PrecomPriceProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="d-flex align-items-center justify-content-center gap">
      {preComPrice ? (
        <div
          className={`precom-price-status rounded-pill ${
            quoteStatus ? 'bg-success-subtle text-success-emphasis' : 'bg-danger-subtle text-danger-emphasis'
          }`}
        >
          {quoteStatus
            ? formatMessage({ id: 'tradeAllocation.monetarySchedule.preComPrice.on' })
            : formatMessage({ id: 'tradeAllocation.monetarySchedule.preComPrice.off' })}
        </div>
      ) : (
        <div className="text-secondary">
          {formatMessage({ id: 'tradeAllocation.monetarySchedule.preComPrice.unavailable' })}
        </div>
      )}
    </div>
  );
};

export default PrecomPrice;
